export default __webpack_public_path__ + "static/media/icon-Hegic_sm.9457ef55.svg";